import { createAsyncThunk } from 'legacy/lut/store/utils/createAsyncThunk'

import { fetchSidebarAssortmentCategories } from '../api/fetchSidebarAssortmentCategories'
import { REQUEST_ASSORTMENT_CATEGORIES } from '../constants'

export const requestAssortmentCategories = createAsyncThunk(
  REQUEST_ASSORTMENT_CATEGORIES,
  fetchSidebarAssortmentCategories
)
